import { Box, Typography } from '@mui/material';
import { cx } from '../../helpers/global';
import { formatDollarAmount } from '../../utils/global/helper';

export default function PaymentLineItem({
  subtract,
  label,
  value,
  isTotal,
  subtractColor,
  useSpecStyle,
}: {
  subtract?: boolean;
  label: string;
  value: number | string;
  isTotal?: boolean;
  subtractColor?: string;
  useSpecStyle?: boolean;
}) {
  return (
    <Box
      className={cx('payment-section-row', isTotal && 'total')}
      sx={
        isTotal
          ? {
              paddingTop: '10px',
              borderTop: theme =>
                `1px solid ${
                  useSpecStyle
                    ? 'var(--sidebar-hairline)'
                    : theme.palette.darkGrey.main
                }`,
            }
          : undefined
      }>
      <Typography
        variant={useSpecStyle ? undefined : isTotal ? 'h3' : 'body1'}
        sx={
          useSpecStyle
            ? {
                fontSize: isTotal
                  ? 'var(--sidebar-font-md)'
                  : 'var(--sidebar-font-base)',
                fontWeight: isTotal ? 700 : 400,
                color: isTotal ? 'var(--sidebar-ink)' : 'var(--sidebar-body)',
              }
            : undefined
        }
        component="p">
        {label}
      </Typography>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          variant={useSpecStyle ? undefined : isTotal ? 'h1' : 'body1'}
          color={
            useSpecStyle || subtractColor
              ? undefined
              : subtract
              ? isTotal
                ? 'secondary'
                : 'primary'
              : undefined
          }
          sx={
            useSpecStyle
              ? {
                  fontSize: isTotal
                    ? 'var(--sidebar-font-md)'
                    : 'var(--sidebar-font-base)',
                  fontWeight: isTotal ? 700 : 600,
                  color: subtractColor ?? 'var(--sidebar-ink)',
                }
              : subtract && subtractColor
              ? { color: subtractColor }
              : undefined
          }
          component="p">
          {typeof subtract === 'boolean' && subtract && !isTotal ? '-' : ''}
          {typeof value === 'number'
            ? formatDollarAmount(value, value === 0)
            : value}
        </Typography>
      </div>
    </Box>
  );
}
